import * as React from 'react';

import { getTermValue } from '@/packages/JsonQuery';
import { type ELayoutType } from '@/packages/api-models/common/json_query';

import { Layout } from '../../../components/advancedFilters/Layout';
import { useFiltersContext } from '../../../utils/context';
import { useOfferType } from '../../../utils/useOfferType';

export const LayoutContainer: React.FC = () => {
  const { jsonQuery, onChange } = useFiltersContext();
  const offerType = useOfferType();
  const layout = getTermValue('room_type')(jsonQuery);
  const withLayout = getTermValue('with_layout')(jsonQuery);

  const handleLayoutTypeChange = React.useCallback(
    // eslint-disable-next-line @typescript-eslint/no-shadow
    (layout: ELayoutType | null) => {
      onChange({ action: 'setLayoutType', arguments: [layout] });
    },
    [onChange],
  );

  const handleWithLayoutChange = React.useCallback(
    // eslint-disable-next-line @typescript-eslint/no-shadow
    (withLayout: boolean | null) => {
      onChange({ action: 'setWithLayout', arguments: [withLayout] });
    },
    [onChange],
  );

  return (
    <Layout
      layoutType={layout}
      offerType={offerType}
      withLayout={withLayout}
      onLayoutTypeChange={handleLayoutTypeChange}
      onWithLayoutChange={handleWithLayoutChange}
    />
  );
};
